import React from "react";

const PrivacyStoobs = () => {
    return <div className="app">
        <div
            id={"form"}
            className={"layer full-screen"}
            style={{overflowY: "scroll", display: "block"}}
        >
            <div className="container">
                <div className="row">
                    <div className="col-8 col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 ms-auto me-auto">
                        <div id={"search-form"} className="search-form row g-3">
                            <div className="col-12">
                                <h1>Privacy Policy for Stoobs</h1>

                                <p>
                                    <strong>Effective Date:</strong> 27.06.2026
                                </p>

                                <p>
                                    This Privacy Policy applies to the Stoobs mobile application for iOS and Android
                                    ("Stoobs", "app", "we", "our", or "us"). It explains what personal data we
                                    process when you use the app, for what purposes, on what legal basis, with whom
                                    we share data, and what rights you have under the General Data Protection
                                    Regulation ("GDPR") and other applicable data protection laws.
                                </p>

                                <p>
                                    Stoobs is a reminder app. To provide reminder scheduling, synchronization, and push
                                    notification delivery, we do process personal data and device-related data. The
                                    previous statement that no data is collected does <strong>not</strong> apply to
                                    Stoobs.
                                </p>

                                <h2>1. Data Controller</h2>
                                <p>
                                    The controller responsible for the processing described in this Privacy Policy is:
                                </p>
                                <p>
                                    <strong>Stoobs</strong><br/>
                                    Michael Böhm<br/>
                                    Königsbrücker Str. 91<br/>
                                    01099 Dresden<br/>
                                    Germany<br/>
                                    +4915788414388<br/>
                                    <a href={`mailto:michael.boehm1988@gmail.com`}>michael.boehm1988@gmail.com</a>
                                </p>

                                <h2>2. What Stoobs Does Not Do</h2>
                                <p>
                                    Stoobs currently does <strong>not</strong> use advertising SDKs, behavior
                                    profiling, cross-app tracking, or analytics tools such as Google Analytics,
                                    Amplitude, Mixpanel, or similar services.
                                </p>
                                <p>
                                    Stoobs also does not request or process your precise location, contacts, microphone,
                                    or camera data. The only image-related processing takes place if you voluntarily
                                    attach a screenshot to a bug report.
                                </p>

                                <h2>3. Categories of Data We Process</h2>
                                <p>Depending on how you use the app, we process the following categories of data:</p>
                                <ul>
                                    <li>
                                        <strong>Authentication and account data:</strong> a Firebase user ID (UID) and
                                        authentication status. By default, Stoobs signs you in anonymously. If you use
                                        optional email/password sign-up or sign-in, Firebase Authentication also
                                        processes your email address and password. We do not store your plaintext
                                        password ourselves.
                                    </li>
                                    <li>
                                        <strong>User profile data:</strong> app-related account fields such as locale,
                                        UTC offset / time zone offset, subscription status, account creation timestamp,
                                        the push notification token assigned to your device, and a compact snapshot of
                                        the last device used, consisting of platform, operating system and version, and
                                        device model.
                                    </li>
                                    <li>
                                        <strong>Reminder content you enter:</strong> reminder titles, optional icons,
                                        notes, list entries, chosen weekdays, time ranges, interval settings,
                                        repetition settings, minimum time-between settings, color selections, active
                                        status, and scheduled notification timestamps.
                                    </li>
                                    <li>
                                        <strong>Scheduling and delivery data:</strong> technical scheduling entries
                                        required to calculate and send future reminders, including notification
                                        timestamps and backend processing metadata.
                                    </li>
                                    <li>
                                        <strong>Push notification data:</strong> your device's push token and the
                                        notification payload needed to deliver reminders, including reminder text,
                                        optional notes text, and reminder color metadata. Depending on your device
                                        settings, reminder content may appear on the lock screen or in notification
                                        previews.
                                    </li>
                                    <li>
                                        <strong>Bug report data:</strong> if you submit a bug report in the app, we
                                        process the description you enter, your optional contact email address, an
                                        optional screenshot, and optional client context such as locale, UTC offset,
                                        theme preference, app version, platform, operating system and version, device
                                        model, and your authenticated UID. Device context is collected again when the
                                        report is submitted so it reflects the environment in which the issue occurred.
                                    </li>
                                    <li>
                                        <strong>Correspondence data:</strong> if you contact us by email, we process
                                        your email address and the content of your request and any follow-up
                                        communication.
                                    </li>
                                    <li>
                                        <strong>Local device storage:</strong> Stoobs stores certain data locally on
                                        your device to make the app usable and responsive, including cached reminders,
                                        cached current user data, selected language, theme preference, intro state,
                                        and a hidden debug flag.
                                    </li>
                                    <li>
                                        <strong>Technical provider data:</strong> when Firebase / Google Cloud and, on
                                        iOS, Apple Push Notification service are used to provide the app, those
                                        providers may also process technical metadata such as IP addresses, device or
                                        connection information, timestamps, and service logs under their own
                                        infrastructure responsibility.
                                    </li>
                                </ul>

                                <h2>4. Purposes of Processing and Legal Bases</h2>
                                <p>We process the above data for the following purposes and legal bases:</p>
                                <ul>
                                    <li>
                                        <strong>Providing the core app service</strong>, including account assignment,
                                        user-specific reminder storage, reminder editing, synchronization, scheduling,
                                        and delivery of reminder notifications: <strong>Art. 6(1)(b) GDPR</strong>
                                        (performance of a contract or pre-contractual steps initiated by you).
                                    </li>
                                    <li>
                                        <strong>Enabling push notifications</strong> after you choose to allow them in
                                        your device settings, including storing the push token and sending reminder
                                        content to your device: <strong>Art. 6(1)(b) GDPR</strong>. Device-level
                                        notification permission is controlled by you and can be changed at any time in
                                        your operating system settings.
                                    </li>
                                    <li>
                                        <strong>Operating the app reliably</strong>, including local caching, timezone
                                        updates, rescheduling when offsets change, operational logging, error handling,
                                        and protection against misuse or service disruption:
                                        <strong>Art. 6(1)(f) GDPR</strong> (our legitimate interest in operating a
                                        stable and secure app).
                                    </li>
                                    <li>
                                        <strong>Handling support and bug reports</strong>, including optional follow-up
                                        communication if you provide a contact email:
                                        <strong>Art. 6(1)(b) GDPR</strong> and
                                        <strong>Art. 6(1)(f) GDPR</strong>.
                                    </li>
                                    <li>
                                        <strong>Responding to direct email inquiries</strong> and handling data
                                        subject requests: <strong>Art. 6(1)(b) GDPR</strong>,
                                        <strong>Art. 6(1)(c) GDPR</strong>, and
                                        <strong>Art. 6(1)(f) GDPR</strong>, depending on the nature of the request.
                                    </li>
                                    <li>
                                        <strong>Complying with legal obligations</strong>, if and to the extent we are
                                        required to do so by law: <strong>Art. 6(1)(c) GDPR</strong>.
                                    </li>
                                </ul>

                                <h2>5. Third-Party Services and Recipients</h2>
                                <p>
                                    To operate Stoobs, we use third-party infrastructure providers. Data may be
                                    disclosed to the following categories of recipients to the extent necessary:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Google Firebase Authentication</strong> for anonymous authentication
                                        and optional email/password authentication.
                                    </li>
                                    <li>
                                        <strong>Google Cloud Firestore / Firebase Firestore</strong> for storing user
                                        records, reminders, scheduling data, and bug report metadata.
                                    </li>
                                    <li>
                                        <strong>Google Cloud Functions for Firebase</strong> for backend business
                                        logic, scheduling, reminder processing, and authenticated API calls.
                                    </li>
                                    <li>
                                        <strong>Firebase Cloud Messaging (FCM)</strong> for push notification delivery.
                                    </li>
                                    <li>
                                        <strong>Google Cloud Storage for Firebase</strong> for storing optional bug
                                        report screenshots.
                                    </li>
                                    <li>
                                        <strong>Apple Push Notification service (APNs)</strong> for delivering iOS push
                                        notifications.
                                    </li>
                                    <li>
                                        <strong>Apple App Store and/or Google Play</strong>, if you download or update
                                        Stoobs through those stores. The respective store operator processes data under
                                        its own responsibility according to its own privacy information.
                                    </li>
                                </ul>

                                <p>
                                    More information about Firebase privacy and data processing is available here:
                                    <br/>
                                    <a
                                        target={"_blank"}
                                        rel="noreferrer"
                                        href={`https://firebase.google.com/support/privacy`}
                                    >
                                        https://firebase.google.com/support/privacy
                                    </a>
                                </p>

                                <p>
                                    Information about Google Cloud and GDPR is available here:
                                    <br/>
                                    <a
                                        target={"_blank"}
                                        rel="noreferrer"
                                        href={`https://cloud.google.com/privacy/gdpr`}
                                    >
                                        https://cloud.google.com/privacy/gdpr
                                    </a>
                                </p>

                                <p>
                                    Apple's privacy information is available here:
                                    <br/>
                                    <a
                                        target={"_blank"}
                                        rel="noreferrer"
                                        href={`https://www.apple.com/legal/privacy/`}
                                    >
                                        https://www.apple.com/legal/privacy/
                                    </a>
                                </p>

                                <h2>6. International Data Transfers</h2>
                                <p>
                                    Because Stoobs uses infrastructure provided by Google and, on iOS, Apple, your data
                                    may be processed outside the European Union or the European Economic Area. Where
                                    required by law, such transfers are based on the safeguards offered by the
                                    respective provider under applicable data protection law, such as standard
                                    contractual clauses and/or other lawful transfer mechanisms, where applicable.
                                </p>

                                <h2>7. Data Retention</h2>
                                <p>
                                    We retain data only for as long as it is needed for the respective purpose, unless
                                    a longer retention period is required by law or necessary to establish, exercise,
                                    or defend legal claims.
                                </p>
                                <ul>
                                    <li>
                                        <strong>User and reminder data:</strong> stored until deleted by you, deleted
                                        as part of account deletion, or manually deleted following a verified support
                                        request.
                                    </li>
                                    <li>
                                        <strong>Technical scheduling entries:</strong> stored only as long as they are
                                        required for future reminder delivery and then removed during normal schedule
                                        processing.
                                    </li>
                                    <li>
                                        <strong>Push tokens:</strong> stored until replaced, invalidated, or removed as
                                        part of account deletion.
                                    </li>
                                    <li>
                                        <strong>Local device cache:</strong> remains on your device until cleared by the
                                        app, removed when you sign out locally, or deleted when you remove app data /
                                        uninstall the app.
                                    </li>
                                    <li>
                                        <strong>Bug reports and screenshots:</strong> currently there is no fixed
                                        automated deletion period. They are retained until they are no longer required
                                        for support, debugging, stability improvement, abuse prevention, or legal
                                        documentation, and are then deleted manually.
                                    </li>
                                </ul>

                                <p>
                                    <strong>Important:</strong> signing out of the app primarily clears local app data.
                                    It does not by itself guarantee immediate deletion of server-side data associated
                                    with your Stoobs account. If you want server-side deletion, please contact us.
                                </p>

                                <h2>8. Your Rights Under the GDPR</h2>
                                <p>Subject to the legal requirements, you have the following rights:</p>
                                <ul>
                                    <li>right of access (Art. 15 GDPR),</li>
                                    <li>right to rectification (Art. 16 GDPR),</li>
                                    <li>right to erasure (Art. 17 GDPR),</li>
                                    <li>right to restriction of processing (Art. 18 GDPR),</li>
                                    <li>right to data portability (Art. 20 GDPR),</li>
                                    <li>right to object (Art. 21 GDPR), and</li>
                                    <li>
                                        right to lodge a complaint with a supervisory authority, in particular the
                                        authority responsible for your place of residence or for us as controller.
                                    </li>
                                </ul>

                                <p>
                                    The supervisory authority in Saxony can be found here:
                                    <br/>
                                    <a
                                        target={"_blank"}
                                        rel="noreferrer"
                                        href={`https://www.datenschutz.sachsen.de/`}
                                    >
                                        https://www.datenschutz.sachsen.de/
                                    </a>
                                </p>

                                <p>
                                    If you want to exercise your rights, please contact us at{" "}
                                    <a href={`mailto:michael.boehm1988@gmail.com`}>michael.boehm1988@gmail.com</a>. Because
                                    Stoobs often uses anonymous accounts, we may need additional information from you
                                    to reliably identify the relevant account before fulfilling a request.
                                </p>

                                <h2>9. Voluntary Information and Sensitive Content</h2>
                                <p>
                                    You control the text you enter into reminders, list items, notes, and bug reports.
                                    Please avoid entering unnecessary sensitive information in reminder texts or notes,
                                    especially if you use lock-screen notification previews.
                                </p>

                                <h2>10. Security Measures</h2>
                                <p>
                                    We use appropriate technical and organizational measures to protect data against
                                    unauthorized access, loss, misuse, or unlawful alteration. This includes
                                    authenticated backend access, Firebase infrastructure controls, and access-limited
                                    handling of app data and bug reports. However, no system can be guaranteed to be
                                    completely secure.
                                </p>

                                <h2>11. Changes to This Privacy Policy</h2>
                                <p>
                                    We may update this Privacy Policy from time to time, for example if the app
                                    changes, legal requirements change, or we introduce new processing activities. The
                                    latest version will be published on this page with an updated effective date.
                                </p>

                                <h2>12. Contact</h2>
                                <p>
                                    If you have questions about this Privacy Policy or your personal data, please
                                    contact us at:
                                    <br/>
                                    <a href={`mailto:michael.boehm1988@gmail.com`}>michael.boehm1988@gmail.com</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id={"bg-image"} className={"layer full-screen"}/>
    </div>;
};

export default PrivacyStoobs;
